import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

interface SearchMagnifyProps extends BoxProps<'svg'> {
  color?: string
}

const SearchMagnify: FC<SearchMagnifyProps> = ({
  color = '#FF612B', // ✅ default color
  ...props
}) => (
  <Box
    component={'svg'}
    width={40}
    height={40}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.5 14H14.71L14.43 13.73C15.63 12.33 16.25 10.42 15.91 8.39002C15.44 5.61002 13.12 3.39002 10.32 3.05002C6.09001 2.53002 2.53002 6.09001 3.05002 10.32C3.39002 13.12 5.61002 15.44 8.39002 15.91C10.42 16.25 12.33 15.63 13.73 14.43L14 14.71V15.5L18.25 19.75C18.66 20.16 19.33 20.16 19.74 19.75C20.15 19.34 20.15 18.67 19.74 18.26L15.5 14ZM9.50002 14C7.01002 14 5.00002 11.99 5.00002 9.50002C5.00002 7.01002 7.01002 5.00002 9.50002 5.00002C11.99 5.00002 14 7.01002 14 9.50002C14 11.99 11.99 14 9.50002 14Z"
      fill={color}
    />
  </Box>
)
export default SearchMagnify
